var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import srciLogicSdk from "@payair/srci-logic-sdk";
import { SrciButtonSizeEnumsObj } from "../../enums/SrciButtonSizeEnum";
import { defineCustomElement as defineSrciButton, SrciButton } from "@payair/srci-ui-sdk/custom-elements/srci-button";
import { defineCustomElement as defineNewUserScreen, NewUserScreen, } from "@payair/srci-ui-sdk/custom-elements/new-user-screen";
import { defineCustomElement as defineOtpChannel, OtpChannel } from "@payair/srci-ui-sdk/custom-elements/otp-channel";
import { defineCustomElement as defineCardListScreen, CardListScreen, } from "@payair/srci-ui-sdk/custom-elements/card-list-screen";
import { defineCustomElement as defineLoginScreen, LoginScreen } from "@payair/srci-ui-sdk/custom-elements/login-screen";
import { defineCustomElement as defineAddCardScreen, AddCardScreen, } from "@payair/srci-ui-sdk/custom-elements/add-card-screen";
import { DcfSdkEnumsObj } from "../../enums/DcfSdkEnum";
import { SrciScreenEnumsObj } from "../../enums/internal/SrciScreenEnum";
import { SrciEventTypeEnumsObj } from "../../enums/SrciEventTypeEnum";
import { updateScreen } from "../SrciSdk";
import { ErrorCodesObj, getErrorInfoMessageString, SomethingWentWrongErrorCodesObj, } from "../../helpers/ErrorMapper";
import { getRandomString } from "../../helpers/CommonFunctions";
import { SrciOtpScreen } from "./SrciOtpScreen";
import { ConsumerInfoDraftController } from "../consumer/ConsumerInfoDraftController";
import { createCardHolderInfo, copySrciConsumer, createConsumerInfoFormConfig, getChangedConsumerInfoFields, hasNonFieldConsumerInfoErrors, toConsumerInfoFormErrors, } from "../consumer/ConsumerInfoFormAdapter";
import { mapConsumerForNetwork, toMappedConsumerPayment, toRecognizedAddCardPayment, } from "../consumer/ConsumerPaymentMapping";
import { ensurePaymentSheetStyles } from "../PaymentSheetStyles";
import { adaptConsumerCheckoutErrors } from "../consumer/ConsumerCheckoutErrorAdapter";
import { buildReasonTelemetry } from "../telemetry/SrciTelemetry";
var ID_FORMAT_UNSUPPORTED = "ID_FORMAT_UNSUPPORTED";
/** @internal */ export var srciUiComponentId = "srciUiComponent-".concat(getRandomString());
/** @internal */ export var defaultPaymentSheetContainerId = "payairSrciPaymentSheet-".concat(getRandomString());
/** @internal */
var SrciUiSdk = /** @class */ (function () {
    function SrciUiSdk(srciLogic, languageHandler, eventReporter) {
        var _this = this;
        this.consumerInfoExternalErrors = [];
        this.getErrorInfoMessage = function (reason) {
            return getErrorInfoMessageModel("ERROR", [{ reason: reason }], _this.languageHandler);
        };
        this.reportUnexpectedUiError = function (operation, network) {
            _this.eventReporter.sendEvent(SrciEventTypeEnumsObj.UNEXPECTED_UI_ERROR, __assign({ operation: operation, reason: SomethingWentWrongErrorCodesObj.SERVER_ERROR }, (network ? { network: network } : {})));
        };
        this.getIdentityLookupInfoMessage = function (errorsList) {
            if (errorsList.length === 0)
                return undefined;
            if (errorsList.length === 1 && errorsList[0].reason === ErrorCodesObj.EMPTY_PROFILE_LIST) {
                return getErrorInfoMessageModel("ALERT", errorsList, _this.languageHandler);
            }
            var isIdentityFormatError = function (error) {
                return typeof error.reason === "object" && error.reason.reason === ID_FORMAT_UNSUPPORTED;
            };
            var errorType = errorsList.every(isIdentityFormatError) ? "ALERT" : "ERROR";
            var displayErrors = errorsList.map(function (error) {
                return isIdentityFormatError(error) ? { reason: ErrorCodesObj.EMAIL_INVALID } : error;
            });
            return getErrorInfoMessageModel(errorType, displayErrors, _this.languageHandler);
        };
        this.getSrciButton = function (srciButtonParams, locale, mastercardState, visaState, startPaymentImpl) {
            var srciButton = new SrciButton();
            if (srciButtonParams.buttonType) {
                _this.customPaymentMethod = srciButtonParams.buttonType;
                srciButton.paymentMethod = getPaymentMethod(mastercardState, visaState, _this.customPaymentMethod);
            }
            else {
                srciButton.paymentMethod = getPaymentMethod(mastercardState, visaState);
            }
            var buttonLocale = srciButtonParams.buttonLocale ? srciButtonParams.buttonLocale : locale;
            if (!buttonLocale) {
                console.error("srciInitParams.locale or srciButtonParams.buttonLocale is invalid.");
                return null;
            }
            srciButton.locale = buttonLocale;
            srciButton.srciButtonSize = srciButtonParams.buttonSize
                ? srciButtonParams.buttonSize
                : SrciButtonSizeEnumsObj.MEDIUM;
            if (typeof srciButtonParams.buttonOnClick === "function") {
                srciButton.srciButtonOnClick = srciButtonParams.buttonOnClick;
            }
            else {
                srciButton.srciButtonOnClick = function () { return startPaymentImpl(); };
            }
            return srciButton;
        };
        this.getLoginScreen = function (commonState, mastercardState, visaState, locale, isCloseButtonEnabled) { return __awaiter(_this, void 0, void 0, function () {
            var element;
            var _this = this;
            return __generator(this, function (_a) {
                if (!locale) {
                    return [2 /*return*/, undefined];
                }
                element = new LoginScreen();
                element.locale = locale;
                element.paymentMethod = getPaymentMethod(mastercardState, visaState, this.customPaymentMethod);
                element.continueButtonOnClick = function (loginScreenState) { return __awaiter(_this, void 0, void 0, function () {
                    var errorsList, _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                element.isLoading = true;
                                if (!loginScreenState.email) {
                                    element.isLoading = false;
                                    element.infoMessage = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.EMAIL_NOT_DEFINED }], this.languageHandler);
                                    return [2 /*return*/];
                                }
                                if (!srciLogicSdk.isEmailValid(loginScreenState.email)) {
                                    element.isLoading = false;
                                    element.infoMessage = getErrorInfoMessageModel("ALERT", [{ reason: ErrorCodesObj.EMAIL_INVALID }], this.languageHandler);
                                    return [2 /*return*/];
                                }
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 5, 6, 7]);
                                return [4 /*yield*/, this.srciLogic.callIdentityLookup(commonState, loginScreenState.email)];
                            case 2:
                                errorsList = _b.sent();
                                if (!commonState.isConsumerPresent) return [3 /*break*/, 4];
                                return [4 /*yield*/, updateScreen(SrciScreenEnumsObj.OTP_SCREEN)];
                            case 3:
                                _b.sent();
                                return [2 /*return*/];
                            case 4:
                                element.infoMessage = this.getIdentityLookupInfoMessage(errorsList);
                                return [3 /*break*/, 7];
                            case 5:
                                _a = _b.sent();
                                // Identity lookup owns its lifecycle error; this boundary only restores the UI state.
                                element.infoMessage = this.getErrorInfoMessage(SomethingWentWrongErrorCodesObj.SERVER_ERROR);
                                return [3 /*break*/, 7];
                            case 6:
                                element.isLoading = false;
                                return [7 /*endfinally*/];
                            case 7: return [2 /*return*/];
                        }
                    });
                }); };
                element.newAccountOnClick = function () {
                    updateScreen(SrciScreenEnumsObj.NEW_USER_SCREEN);
                };
                if (isCloseButtonEnabled !== false)
                    element.closeButtonOnClick = function () {
                        return _this.srciLogic.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_BY_USER);
                    };
                return [2 /*return*/, element];
            });
        }); };
        this.getAddCardScreen = function (commonState, mastercardState, visaState, locale, isCloseButtonEnabled) { return __awaiter(_this, void 0, void 0, function () {
            var paymentMethod, element, consumerInfoController, consumerInfoConfig, selectedConsumerMapping, userCredentials;
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                if (!locale) {
                    return [2 /*return*/, undefined];
                }
                if (!commonState.initParams) {
                    return [2 /*return*/, undefined];
                }
                paymentMethod = getPaymentMethod(mastercardState, visaState);
                if (!isCardEnrollmentPaymentMethod(paymentMethod)) {
                    return [2 /*return*/, undefined];
                }
                element = new AddCardScreen();
                element.locale = locale;
                element.paymentMethod = paymentMethod;
                element.env = commonState.initParams.environment;
                element.psp = commonState.initParams.pspName;
                consumerInfoController = new ConsumerInfoDraftController(copySrciConsumer(commonState.initParams.srciConsumer), locale);
                consumerInfoConfig = createConsumerInfoFormConfig((_a = commonState.initParams.srciBillingAddress) === null || _a === void 0 ? void 0 : _a.countryCode);
                this.updateAddCardConsumerInfoScreen(element, commonState, consumerInfoConfig, consumerInfoController);
                element.consumerInfoOnChange = function (candidate) {
                    return _this.handleAddCardConsumerInfoChange(element, commonState, consumerInfoConfig, consumerInfoController, candidate);
                };
                element.cardValidationOnChange = function (validation) {
                    var _a, _b;
                    if (!_this.isCardBrandSupportedByMerchant(validation.cardBrand, mastercardState, visaState)) {
                        return false;
                    }
                    consumerInfoConfig = createConsumerInfoFormConfig((_b = (_a = commonState.initParams) === null || _a === void 0 ? void 0 : _a.srciBillingAddress) === null || _b === void 0 ? void 0 : _b.countryCode, validation.cardBrand);
                    selectedConsumerMapping = undefined;
                    element.consumerInfoErrors = [];
                    element.infoMessage = undefined;
                    _this.updateAddCardConsumerInfoScreen(element, commonState, consumerInfoConfig, consumerInfoController);
                    return true;
                };
                element.invalidCardOnChange = function () {
                    selectedConsumerMapping = undefined;
                    element.consumerInfoErrors = [];
                    element.infoMessage = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.CARD_NOT_RECOGNIZED }], _this.languageHandler);
                };
                element.prepareStoreAndPay = function (cardBrand) {
                    selectedConsumerMapping = _this.prepareRecognizedAddCardStoreAndPay(commonState, cardBrand, element, consumerInfoController);
                    return Boolean(selectedConsumerMapping);
                };
                element.notYouOnClick = function () { return __awaiter(_this, void 0, void 0, function () {
                    var unbindErrors;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.srciLogic.unbindAppInstance(commonState, mastercardState, visaState)];
                            case 1:
                                unbindErrors = _a.sent();
                                if (unbindErrors && unbindErrors.length > 0) {
                                    element.infoMessage = getErrorInfoMessageModel("ALERT", unbindErrors, this.languageHandler);
                                }
                                else {
                                    updateScreen(SrciScreenEnumsObj.NEW_USER_SCREEN);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); };
                element.addCardButtonOnClick = function (cardModel) {
                    return _this.handleRecognizedAddCardEncryptedCard(commonState, mastercardState, visaState, cardModel, element, selectedConsumerMapping);
                };
                element.selectCardButtonOnClick = function () {
                    updateScreen(SrciScreenEnumsObj.CARD_LIST_SCREEN, true);
                };
                userCredentials = ((_b = mastercardState.getProfileResponse) === null || _b === void 0 ? void 0 : _b.profiles) &&
                    ((_d = (_c = mastercardState.getProfileResponse) === null || _c === void 0 ? void 0 : _c.profiles[0].maskedConsumer) === null || _d === void 0 ? void 0 : _d.maskedEmailAddress);
                if (!userCredentials) {
                    userCredentials =
                        ((_e = visaState.getProfileResponse) === null || _e === void 0 ? void 0 : _e.profiles) && ((_g = (_f = visaState.getProfileResponse) === null || _f === void 0 ? void 0 : _f.profiles[0].maskedConsumer) === null || _g === void 0 ? void 0 : _g.emailAddress);
                }
                if (userCredentials) {
                    element.userCredentials = userCredentials;
                }
                if (isCloseButtonEnabled !== false)
                    element.closeButtonOnClick = function () {
                        return _this.srciLogic.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_BY_USER);
                    };
                if (commonState.addCardForNoCardsCase) {
                    element.hideSelectCardButton = true;
                }
                return [2 /*return*/, element];
            });
        }); };
        this.handleRecognizedAddCardEncryptedCard = function (commonState, mastercardState, visaState, screenState, element, selectedMapping) { return __awaiter(_this, void 0, void 0, function () {
            var cardBrand, encryptedCard, idToken, payment, errorsList, adaptedErrors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!screenState.encryptedCard.isCardNumberValid ||
                            !screenState.encryptedCard.isCardSecurityCodeValid ||
                            !screenState.encryptedCard.isPanExpirationDateValid) {
                            return [2 /*return*/];
                        }
                        if (!commonState.initParams) {
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.SDK_INITIALIZE_ERROR, buildReasonTelemetry("SDK_NOT_INITIALIZED"));
                            return [2 /*return*/];
                        }
                        cardBrand = screenState.encryptedCard.cardBrand;
                        encryptedCard = screenState.encryptedCard.value;
                        element.infoMessage = undefined;
                        if (!this.isCardBrandSupportedByMerchant(cardBrand, mastercardState, visaState) ||
                            !selectedMapping ||
                            selectedMapping.cardBrand !== cardBrand) {
                            element.infoMessage = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.CARD_NOT_RECOGNIZED }], this.languageHandler);
                            return [2 /*return*/];
                        }
                        element.consumerInfoErrors = [];
                        idToken = this.srciLogic.getRecognizedAddCardIdToken(cardBrand, mastercardState, visaState);
                        if (!idToken) {
                            element.infoMessage = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.AUTH_INVALID, dcf: cardBrand }], this.languageHandler);
                            return [2 /*return*/];
                        }
                        payment = toRecognizedAddCardPayment(selectedMapping, encryptedCard, idToken);
                        if (!payment) {
                            return [2 /*return*/];
                        }
                        element.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 5, 6]);
                        return [4 /*yield*/, this.srciLogic.processRecognizedAddCardPayment(commonState, mastercardState, visaState, payment)];
                    case 2:
                        errorsList = _a.sent();
                        if (!(errorsList.length > 0)) return [3 /*break*/, 4];
                        adaptedErrors = adaptConsumerCheckoutErrors(errorsList);
                        element.consumerInfoErrors = adaptedErrors.fieldErrors;
                        element.infoMessage = adaptedErrors.generalErrors.length
                            ? getErrorInfoMessageModel("ERROR", adaptedErrors.generalErrors, this.languageHandler)
                            : undefined;
                        if (!adaptedErrors.shouldReturnToCardStep) return [3 /*break*/, 4];
                        return [4 /*yield*/, element.returnToCardStep()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        element.isLoading = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.prepareRecognizedAddCardStoreAndPay = function (commonState, cardBrand, element, consumerInfoController) {
            var _a;
            if (!commonState.initParams) {
                _this.eventReporter.sendEvent(SrciEventTypeEnumsObj.SDK_INITIALIZE_ERROR, buildReasonTelemetry("SDK_NOT_INITIALIZED"));
                return undefined;
            }
            var selectedMapping = mapConsumerForNetwork(cardBrand, consumerInfoController.snapshot().resolvedValue, (_a = commonState.initParams.srciBillingAddress) === null || _a === void 0 ? void 0 : _a.countryCode, true);
            if (!selectedMapping) {
                element.consumerInfoErrors = [];
                element.infoMessage = getErrorInfoMessageModel("ERROR", [_this.getConsumerMappingGeneralError(cardBrand)], _this.languageHandler);
                return undefined;
            }
            if (!selectedMapping.result.value) {
                element.consumerInfoErrors = toConsumerInfoFormErrors(selectedMapping.result.errors);
                element.infoMessage = hasNonFieldConsumerInfoErrors(selectedMapping.result.errors)
                    ? getErrorInfoMessageModel("ERROR", [_this.getConsumerMappingGeneralError(cardBrand)], _this.languageHandler)
                    : undefined;
                return undefined;
            }
            element.consumerInfoErrors = [];
            element.infoMessage = undefined;
            return selectedMapping;
        };
        this.updateAddCardConsumerInfoScreen = function (element, commonState, consumerInfoConfig, consumerInfoController) {
            var _a;
            var snapshot = consumerInfoController.snapshot();
            element.consumerInfoValue = snapshot.value;
            element.consumerInfoConfig = consumerInfoConfig;
            element.cardHolderInfo = createCardHolderInfo((_a = commonState.initParams) === null || _a === void 0 ? void 0 : _a.srciBillingAddress, snapshot.resolvedValue);
        };
        this.handleAddCardConsumerInfoChange = function (element, commonState, consumerInfoConfig, consumerInfoController, candidate) {
            var previousValue = consumerInfoController.snapshot().value;
            var changedFields = getChangedConsumerInfoFields(previousValue, candidate);
            consumerInfoController.accept(candidate);
            element.consumerInfoErrors = element.consumerInfoErrors.filter(function (error) { return changedFields.indexOf(error.field) < 0; });
            _this.updateAddCardConsumerInfoScreen(element, commonState, consumerInfoConfig, consumerInfoController);
        };
        this.getNewUserScreen = function (commonState, mastercardState, visaState, locale, isCloseButtonEnabled) { return __awaiter(_this, void 0, void 0, function () {
            var paymentMethod, element, consumerInfoConfig, selectedConsumerMapping;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                if (!locale) {
                    return [2 /*return*/, undefined];
                }
                if (!commonState.initParams) {
                    return [2 /*return*/, undefined];
                }
                paymentMethod = getPaymentMethod(mastercardState, visaState);
                if (!isNewUserPaymentMethod(paymentMethod)) {
                    return [2 /*return*/, undefined];
                }
                element = new NewUserScreen();
                element.locale = locale;
                element.env = commonState.initParams.environment;
                element.psp = commonState.initParams.pspName;
                element.paymentMethod = paymentMethod;
                this.consumerInfoController =
                    this.consumerInfoController || new ConsumerInfoDraftController(commonState.initParams.srciConsumer, locale);
                consumerInfoConfig = createConsumerInfoFormConfig((_a = commonState.initParams.srciBillingAddress) === null || _a === void 0 ? void 0 : _a.countryCode);
                this.updateControlledConsumerInfoScreen(element, commonState, consumerInfoConfig);
                element.consumerInfoOnChange = function (candidate) {
                    return _this.handleConsumerInfoChange(element, commonState, consumerInfoConfig, candidate);
                };
                element.cardValidationOnChange = function (validation) {
                    var _a, _b;
                    if (!_this.isCardBrandSupportedByMerchant(validation.cardBrand, mastercardState, visaState)) {
                        return false;
                    }
                    consumerInfoConfig = createConsumerInfoFormConfig((_b = (_a = commonState.initParams) === null || _a === void 0 ? void 0 : _a.srciBillingAddress) === null || _b === void 0 ? void 0 : _b.countryCode, validation.cardBrand);
                    selectedConsumerMapping = undefined;
                    _this.consumerInfoExternalErrors = [];
                    element.infoMessage = undefined;
                    _this.updateControlledConsumerInfoScreen(element, commonState, consumerInfoConfig);
                    return true;
                };
                element.invalidCardOnChange = function () {
                    selectedConsumerMapping = undefined;
                    _this.consumerInfoExternalErrors = [];
                    element.consumerInfoErrors = [];
                    element.infoMessage = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.CARD_NOT_RECOGNIZED }], _this.languageHandler);
                };
                element.prepareStoreAndPay = function (cardBrand) {
                    selectedConsumerMapping = _this.prepareNewUserStoreAndPay(commonState, cardBrand, element);
                    return Boolean(selectedConsumerMapping);
                };
                element.getStartedButtonOnClick = function (cardModel, rememberMe) {
                    return _this.handleNewUserEncryptedCard(commonState, mastercardState, visaState, cardModel, rememberMe === true, element, selectedConsumerMapping);
                };
                element.changeUserButtonOnClick = function () {
                    updateScreen(SrciScreenEnumsObj.LOGIN_SCREEN);
                };
                if (isCloseButtonEnabled !== false)
                    element.closeButtonOnClick = function () {
                        return _this.srciLogic.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_BY_USER);
                    };
                return [2 /*return*/, element];
            });
        }); };
        this.handleNewUserEncryptedCard = function (commonState, mastercardState, visaState, screenState, rememberMe, element, selectedMapping) { return __awaiter(_this, void 0, void 0, function () {
            var cardBrand, encryptedCard, payment, errorsList, adaptedErrors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!screenState.encryptedCard.isCardNumberValid ||
                            !screenState.encryptedCard.isCardSecurityCodeValid ||
                            !screenState.encryptedCard.isPanExpirationDateValid) {
                            return [2 /*return*/];
                        }
                        if (!commonState.initParams) {
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.SDK_INITIALIZE_ERROR, buildReasonTelemetry("SDK_NOT_INITIALIZED"));
                            return [2 /*return*/];
                        }
                        cardBrand = screenState.encryptedCard.cardBrand;
                        encryptedCard = screenState.encryptedCard.value;
                        if (!this.isCardBrandSupportedByMerchant(cardBrand, mastercardState, visaState) ||
                            !selectedMapping ||
                            selectedMapping.cardBrand !== cardBrand) {
                            element.infoMessage = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.CARD_NOT_RECOGNIZED }], this.languageHandler);
                            return [2 /*return*/];
                        }
                        payment = toMappedConsumerPayment(selectedMapping, encryptedCard, rememberMe);
                        if (!payment) {
                            return [2 /*return*/];
                        }
                        element.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 5, 6]);
                        return [4 /*yield*/, this.srciLogic.processNewUserPayment(commonState, mastercardState, visaState, payment)];
                    case 2:
                        errorsList = _a.sent();
                        if (!(errorsList.length > 0)) return [3 /*break*/, 4];
                        adaptedErrors = adaptConsumerCheckoutErrors(errorsList);
                        this.consumerInfoExternalErrors = adaptedErrors.fieldErrors;
                        element.consumerInfoErrors = this.consumerInfoExternalErrors;
                        element.infoMessage = adaptedErrors.generalErrors.length
                            ? getErrorInfoMessageModel("ERROR", adaptedErrors.generalErrors, this.languageHandler)
                            : undefined;
                        if (!adaptedErrors.shouldReturnToCardStep) return [3 /*break*/, 4];
                        return [4 /*yield*/, element.returnToCardStep()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        element.isLoading = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.prepareNewUserStoreAndPay = function (commonState, cardBrand, element) {
            var _a, _b;
            if (!commonState.initParams) {
                _this.eventReporter.sendEvent(SrciEventTypeEnumsObj.SDK_INITIALIZE_ERROR, buildReasonTelemetry("SDK_NOT_INITIALIZED"));
                return undefined;
            }
            var resolvedConsumer = (_a = _this.consumerInfoController) === null || _a === void 0 ? void 0 : _a.snapshot().resolvedValue;
            if (!resolvedConsumer) {
                element.infoMessage = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.MERCHANT_DATA_INVALID }], _this.languageHandler);
                return undefined;
            }
            var selectedMapping = mapConsumerForNetwork(cardBrand, resolvedConsumer, (_b = commonState.initParams.srciBillingAddress) === null || _b === void 0 ? void 0 : _b.countryCode, true);
            if (!selectedMapping) {
                _this.consumerInfoExternalErrors = [];
                element.consumerInfoErrors = [];
                element.infoMessage = getErrorInfoMessageModel("ERROR", [_this.getConsumerMappingGeneralError(cardBrand)], _this.languageHandler);
                return undefined;
            }
            if (!selectedMapping.result.value) {
                _this.consumerInfoExternalErrors = toConsumerInfoFormErrors(selectedMapping.result.errors);
                element.consumerInfoErrors = _this.consumerInfoExternalErrors;
                element.infoMessage = hasNonFieldConsumerInfoErrors(selectedMapping.result.errors)
                    ? getErrorInfoMessageModel("ERROR", [_this.getConsumerMappingGeneralError(cardBrand)], _this.languageHandler)
                    : undefined;
                return undefined;
            }
            _this.consumerInfoExternalErrors = [];
            element.consumerInfoErrors = [];
            element.infoMessage = undefined;
            return selectedMapping;
        };
        this.isCardBrandSupportedByMerchant = function (cardBrand, mastercardState, visaState) {
            return (cardBrand === DcfSdkEnumsObj.MASTERCARD && mastercardState.isSupported) ||
                (cardBrand === DcfSdkEnumsObj.VISA && visaState.isSupported);
        };
        this.getConsumerMappingGeneralError = function (cardBrand) {
            if (cardBrand === DcfSdkEnumsObj.VISA || cardBrand === DcfSdkEnumsObj.MASTERCARD) {
                return { reason: ErrorCodesObj.MERCHANT_DATA_INVALID, dcf: cardBrand };
            }
            return { reason: ErrorCodesObj.CARD_NOT_RECOGNIZED };
        };
        this.updateControlledConsumerInfoScreen = function (element, commonState, consumerInfoConfig) {
            var _a, _b;
            var snapshot = (_a = _this.consumerInfoController) === null || _a === void 0 ? void 0 : _a.snapshot();
            if (!snapshot) {
                return;
            }
            element.consumerInfoValue = snapshot.value;
            element.consumerInfoConfig = consumerInfoConfig;
            element.consumerInfoErrors = _this.consumerInfoExternalErrors;
            element.cardHolderInfo = createCardHolderInfo((_b = commonState.initParams) === null || _b === void 0 ? void 0 : _b.srciBillingAddress, snapshot.resolvedValue);
        };
        this.handleConsumerInfoChange = function (element, commonState, consumerInfoConfig, candidate) {
            var _a, _b;
            var previousValue = (_a = _this.consumerInfoController) === null || _a === void 0 ? void 0 : _a.snapshot().value;
            if (!previousValue) {
                return;
            }
            var changedFields = getChangedConsumerInfoFields(previousValue, candidate);
            (_b = _this.consumerInfoController) === null || _b === void 0 ? void 0 : _b.accept(candidate);
            _this.consumerInfoExternalErrors = _this.consumerInfoExternalErrors.filter(function (error) { return changedFields.indexOf(error.field) < 0; });
            _this.updateControlledConsumerInfoScreen(element, commonState, consumerInfoConfig);
        };
        this.getOtpScreen = function (commonState, mastercardState, visaState, locale, isCloseButtonEnabled) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.srciOtpScreen.getOtpScreen(commonState, mastercardState, visaState, locale, this.customPaymentMethod, isCloseButtonEnabled)];
            });
        }); };
        this.getOtpChannelScreen = function (commonState, mastercardState, visaState, locale, isCloseButtonEnabled) { return __awaiter(_this, void 0, void 0, function () {
            var element;
            var _this = this;
            return __generator(this, function (_a) {
                if (!locale) {
                    return [2 /*return*/, undefined];
                }
                element = new OtpChannel();
                element.locale = locale;
                element.paymentMethod = getPaymentMethod(mastercardState, visaState, this.customPaymentMethod);
                element.otpData = commonState.otpChannelsData;
                element.continueButtonOnClick = function (data) {
                    if (!data.description) {
                        _this.srciLogic.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_BY_USER);
                    }
                    else {
                        commonState.selectedOtpChannel = data.description;
                        updateScreen(SrciScreenEnumsObj.OTP_SCREEN);
                    }
                };
                if (isCloseButtonEnabled !== false)
                    element.closeButtonOnClick = function () {
                        return _this.srciLogic.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_BY_USER);
                    };
                return [2 /*return*/, element];
            });
        }); };
        this.updateCardListScreen = function (cardListScreen, commonState, mastercardState, visaState) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var cardList = [];
            var isMastercardProfileDefined = false;
            var isVisaProfileDefined = false;
            if (((_a = mastercardState.getProfileResponse) === null || _a === void 0 ? void 0 : _a.profiles) && ((_b = mastercardState.getProfileResponse) === null || _b === void 0 ? void 0 : _b.profiles.length) > 0) {
                var mastercardCardList = mastercardState.getProfileResponse.profiles[0].maskedCards;
                var convertedMaskedCards = _this.convertMaskedCards(mastercardCardList, DcfSdkEnumsObj.MASTERCARD);
                cardList = cardList.concat(convertedMaskedCards);
                isMastercardProfileDefined = true;
            }
            if (((_c = visaState.getProfileResponse) === null || _c === void 0 ? void 0 : _c.profiles) && ((_d = visaState.getProfileResponse) === null || _d === void 0 ? void 0 : _d.profiles.length) > 0) {
                var visaCardList = visaState.getProfileResponse.profiles[0].maskedCards;
                var convertedMaskedCards = _this.convertMaskedCards(visaCardList, DcfSdkEnumsObj.VISA);
                cardList = cardList.concat(convertedMaskedCards);
                isVisaProfileDefined = true;
            }
            cardListScreen.cardList = cardList;
            var userCredentials = ((_e = mastercardState.getProfileResponse) === null || _e === void 0 ? void 0 : _e.profiles) &&
                ((_g = (_f = mastercardState.getProfileResponse) === null || _f === void 0 ? void 0 : _f.profiles[0].maskedConsumer) === null || _g === void 0 ? void 0 : _g.maskedEmailAddress);
            if (!userCredentials) {
                userCredentials =
                    ((_h = visaState.getProfileResponse) === null || _h === void 0 ? void 0 : _h.profiles) && ((_k = (_j = visaState.getProfileResponse) === null || _j === void 0 ? void 0 : _j.profiles[0].maskedConsumer) === null || _k === void 0 ? void 0 : _k.emailAddress);
            }
            if (userCredentials) {
                cardListScreen.userCredentials = userCredentials;
            }
            if (!isMastercardProfileDefined &&
                !isVisaProfileDefined &&
                commonState.profileErrors &&
                commonState.profileErrors.length > 0) {
                cardListScreen.infoMessage = getErrorInfoMessageModel("ERROR", commonState.profileErrors, _this.languageHandler);
            }
            else if (!isMastercardProfileDefined && !isVisaProfileDefined) {
                cardListScreen.infoMessage = getErrorInfoMessageModel("ERROR", [{ reason: ErrorCodesObj.EMPTY_PROFILE_LIST }], _this.languageHandler);
            }
        };
        this.getCardListScreen = function (commonState, mastercardState, visaState, locale, isCloseButtonEnabled, isFetchProfilesEnabled) { return __awaiter(_this, void 0, void 0, function () {
            var cardListScreen;
            var _this = this;
            return __generator(this, function (_a) {
                if (!locale) {
                    return [2 /*return*/, undefined];
                }
                cardListScreen = new CardListScreen();
                if (isFetchProfilesEnabled === true) {
                    cardListScreen.isScreenLoading = true;
                    void (function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, 3, 4]);
                                    return [4 /*yield*/, this.srciLogic.getProfilesAndUpdateState(commonState, mastercardState, visaState)];
                                case 1:
                                    _b.sent();
                                    try {
                                        this.updateCardListScreen(cardListScreen, commonState, mastercardState, visaState);
                                    }
                                    catch (_c) {
                                        this.reportUnexpectedUiError("CARD_LIST_REFRESH");
                                        cardListScreen.infoMessage = this.getErrorInfoMessage(SomethingWentWrongErrorCodesObj.SERVER_ERROR);
                                    }
                                    return [3 /*break*/, 4];
                                case 2:
                                    _a = _b.sent();
                                    cardListScreen.infoMessage = this.getErrorInfoMessage(SomethingWentWrongErrorCodesObj.SERVER_ERROR);
                                    return [3 /*break*/, 4];
                                case 3:
                                    cardListScreen.isScreenLoading = false;
                                    return [7 /*endfinally*/];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); })();
                }
                else {
                    this.updateCardListScreen(cardListScreen, commonState, mastercardState, visaState);
                }
                cardListScreen.locale = locale;
                cardListScreen.paymentMethod = getPaymentMethod(mastercardState, visaState, this.customPaymentMethod);
                cardListScreen.continueButtonOnClick = function (selectedCard) { return __awaiter(_this, void 0, void 0, function () {
                    var errorsList, _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                cardListScreen.isContinueButtonLoading = true;
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, 3, 4, 5]);
                                return [4 /*yield*/, this.srciLogic.processPayment(commonState, mastercardState, visaState, "", selectedCard.dcfSdk, undefined, selectedCard.srcDigitalCardId)];
                            case 2:
                                errorsList = _b.sent();
                                if (errorsList.length > 0) {
                                    cardListScreen.infoMessage = getErrorInfoMessageModel("ERROR", errorsList, this.languageHandler);
                                }
                                return [3 /*break*/, 5];
                            case 3:
                                _a = _b.sent();
                                this.reportUnexpectedUiError("PAYMENT", selectedCard.dcfSdk);
                                cardListScreen.infoMessage = this.getErrorInfoMessage(SomethingWentWrongErrorCodesObj.SERVER_ERROR);
                                return [3 /*break*/, 5];
                            case 4:
                                cardListScreen.isContinueButtonLoading = false;
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); };
                cardListScreen.changeUserOnClick = function () { return __awaiter(_this, void 0, void 0, function () {
                    var unbindErrors;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.srciLogic.unbindAppInstance(commonState, mastercardState, visaState)];
                            case 1:
                                unbindErrors = _a.sent();
                                if (unbindErrors && unbindErrors.length > 0) {
                                    cardListScreen.infoMessage = getErrorInfoMessageModel("ALERT", unbindErrors, this.languageHandler);
                                }
                                else {
                                    updateScreen(SrciScreenEnumsObj.NEW_USER_SCREEN);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); };
                cardListScreen.addCardButtonOnClick = function () {
                    updateScreen(SrciScreenEnumsObj.ADD_CARD_SCREEN);
                };
                if (isCloseButtonEnabled !== false) {
                    cardListScreen.closeButtonOnClick = function () {
                        _this.srciLogic.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_BY_USER);
                    };
                }
                return [2 /*return*/, cardListScreen];
            });
        }); };
        this.convertMaskedCards = function (maskedCards, dcfSdkEnum) {
            return maskedCards.map(function (maskedCard) {
                var isActive = false;
                var cardStatus = maskedCard.digitalCardData.status;
                var isCardStatusAvailable = cardStatus !== undefined;
                var isPanExpirationDateAvailable = Boolean(maskedCard.panExpirationYear && maskedCard.panExpirationMonth);
                var isCardStatusInactive = isCardStatusAvailable && cardStatus !== "ACTIVE";
                var isPanExpired = false;
                if (maskedCard.panExpirationYear && maskedCard.panExpirationMonth) {
                    isPanExpired = !srciLogicSdk.isPanExpirationDateInFuture(maskedCard.panExpirationYear, maskedCard.panExpirationMonth);
                }
                if (dcfSdkEnum === DcfSdkEnumsObj.MASTERCARD) {
                    // Mastercard may omit PAN expiry; treat every available status and expiry signal as a required condition.
                    var hasAvailabilityData = isCardStatusAvailable || isPanExpirationDateAvailable;
                    isActive = hasAvailabilityData && !isCardStatusInactive && !isPanExpired;
                }
                else {
                    isActive = isPanExpirationDateAvailable && !isPanExpired;
                }
                var card = {
                    dcfSdk: dcfSdkEnum,
                    lastFourPan: maskedCard.panLastFour.toString(),
                    dateOfCardCreated: new Date(maskedCard.dateOfCardCreated).getTime(),
                    dateOfCardLastUsed: maskedCard.dateOfCardLastUsed
                        ? new Date(maskedCard.dateOfCardLastUsed).getTime()
                        : undefined,
                    srcDigitalCardId: maskedCard.srcDigitalCardId ? maskedCard.srcDigitalCardId : "",
                    isActive: isActive,
                    artUri: maskedCard.digitalCardData.artUri ? maskedCard.digitalCardData.artUri : "",
                };
                return card;
            });
        };
        this.srciLogic = srciLogic;
        this.languageHandler = languageHandler;
        this.eventReporter = eventReporter;
        this.srciOtpScreen = new SrciOtpScreen(srciLogic, languageHandler);
        defineSrciButton();
        defineNewUserScreen();
        defineOtpChannel();
        defineCardListScreen();
        defineLoginScreen();
        defineAddCardScreen();
        ensurePaymentSheetStyles();
    }
    return SrciUiSdk;
}());
export { SrciUiSdk };
export var getErrorInfoMessageModel = function (infoType, errorsList, languageHandler) {
    if (errorsList.length <= 0)
        return undefined;
    var infoMessage = {
        infoType: infoType,
        infoMessage: getErrorInfoMessageString(errorsList, languageHandler),
    };
    return infoMessage;
};
export var getPaymentMethod = function (mastercardState, visaState, customPaymentMethod) {
    if (customPaymentMethod === undefined) {
        var paymentMethodArray = [];
        mastercardState.isSupported === true && paymentMethodArray.push("master");
        visaState.isSupported === true && paymentMethodArray.push("visa");
        return paymentMethodArray.join(",");
    }
    else {
        return customPaymentMethod;
    }
};
var isCardEnrollmentPaymentMethod = function (paymentMethod) {
    return paymentMethod === "master" || paymentMethod === "visa" || paymentMethod === "master,visa";
};
var isNewUserPaymentMethod = function (paymentMethod) {
    return isCardEnrollmentPaymentMethod(paymentMethod);
};
